import styled from 'styled-components'

const PageContainer = styled.div`
  padding: 10px 20px;
  height: 100%;
`

export default PageContainer
